import { RELOAD_CONTACT_LIST, RELOAD_CONTACT_OVERVIEW } from "../actions/reduxAction";

const INITIAL_STATE = {
  leadsList: [],
  activeLeadsList: null,
  reload_contact_list: false,
  reload_contact_overview: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RELOAD_CONTACT_LIST:
      return {
        ...state,
        reload_contact_list: !state.reload_contact_list // toggling the value
      };
    case RELOAD_CONTACT_OVERVIEW:
      return {
        ...state,
        reload_contact_overview: !state.reload_contact_overview // toggling the value
      };
    default:
      return state;
  }
};
